import { render } from "./RightSidebarLayout.vue?vue&type=template&id=0703d6b8&scoped=true"
import script from "./RightSidebarLayout.vue?vue&type=script&lang=js"
export * from "./RightSidebarLayout.vue?vue&type=script&lang=js"

import "./RightSidebarLayout.vue?vue&type=style&index=0&id=0703d6b8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0703d6b8"],['__file',"src/layouts/student-package/RightSidebarLayout.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0703d6b8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0703d6b8', __exports__)) {
    api.reload('0703d6b8', __exports__)
  }
  
  module.hot.accept("./RightSidebarLayout.vue?vue&type=template&id=0703d6b8&scoped=true", () => {
    api.rerender('0703d6b8', render)
  })

}


export default __exports__